//dependencias
import React, { Component } from 'react';

//componentes
import DosificacionEvaD from './actualizarProfeDosifiD'

class Index extends Component {

    render(){
        return(
            <div>
                <DosificacionEvaD />
            </div>
        );
    }

}
export default Index;